import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/core/services/auth.service';
import { CognitoUserInterface } from '@aws-amplify/ui-components';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.scss']
})
export class StartPageComponent implements OnInit {
  currentUser: CognitoUserInterface | null = null;
  constructor(
    private _auth: AuthService,
  ) { }

  ngOnInit(): void {
    this
    ._auth
    .currentUserChanges()
    .subscribe((user) => {
      this.currentUser = user;
    });
  }

}
